import request from '@/utils/request'

export function index(data) {
  return request({
    url: 'config/index',
    method: 'post',
    data
  })
}

export function get(data) {
  return request({
    url: 'config/get',
    method: 'post',
    data
  })
}

export function set(data) {
  return request({
    url: 'config/set',
    method: 'post',
    data
  })
}


export function dataList(data) {
  return request({
    url: 'config/list',
    method: 'post',
    data
  })
}

export function dataAdd(data) {
  return request({
    url: 'config/add',
    method: 'post',
    data
  })
}

export function dataDelete(data) {
  return request({
    url: 'config/delete',
    method: 'post',
    data
  })
}

export function dataEdit(data) {
  return request({
    url: 'config/edit',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/config.js